import { useEffect, useState } from "react";
import "./sidebar.css";
import Button from "../button/Button";
import handleForm from "../sidebar/pdfApi";
import Alert from "../alert/Alert";
import { host } from "../../constants/backendpath";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useLoader } from "../../context/LoaderContext";

function Sidebar({ setCurrent, admin, current }) {
  const { showLoader, hideLoader } = useLoader();
  const [submitted, setSubmitted] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [alertStage, setAlertStage] = useState("");
  const [alertType, setAlertType] = useState("");
  const [alertMessage, setAlertMessage] = useState("");
  const [alertOkAction, setAlertOkAction] = useState(() => () => {});
  const navigate = useNavigate();

  const handlecloseAlert = () => {
    setShowAlert(false);
  };

  const getFreezed = async () => {
    try {
      const result = await axios.get(`${host}getFreezed`, {
        withCredentials: true,
      });
      // console.log("getFreezed ", result.data[0].freezed);
      if (result.data[0].freezed === "1") {
        setSubmitted(true);
      }
    } catch (err) {
      console.error("Cannot retreieve Freezed state : ", err);
    }
  };

  useEffect(() => {
    getFreezed();
  }, []);

  const handleSubmit = () => {
    setShowAlert(true);
    setAlertMessage(
      "Are you sure you want to submit? You cannot EDIT after this!!!"
    );
    setAlertStage("confirm");
    setAlertType("warning");

    setAlertOkAction(() => () => {
      setShowAlert(true);
      setAlertMessage("You Cannot Edit after this");
      setAlertStage("confirm");
      setAlertType("warning");
      setAlertOkAction(() => () => {
        setShowAlert(true);
        setAlertMessage("Are you sure ! You Cannot Edit after this submit!!!");
        setAlertStage("confirm");
        setAlertType("warning");
        setAlertOkAction(() => async () => {
          try {
            await axios.post(`${host}submit`, {}, { withCredentials: true });
            setSubmitted(true);
            setCurrent(0);
            setAlertMessage("Submitted Successfully!");
            setAlertStage("success");
            setAlertType("success");
            setAlertOkAction(() => () => setShowAlert(false));
          } catch (err) {
            console.error("Submit failed : ", err);
            setAlertMessage("Failed to Submit. Try again.");
            setAlertStage("error");
            setAlertType("error");
            setAlertOkAction(() => () => setShowAlert(false));
          }
        });
      });
    });
  };

  const items = [
    { id: 0, iconId: "homeIcon", label: "Home", action: () => setCurrent(0) },
    {
      id: 1,
      iconId: "collegeIcon",
      label: "College Details",
      action: () => setCurrent(1),
    },
    {
      id: 2,
      iconId: "branchIcon",
      label: "Branchwise Details",
      action: () => setCurrent(2),
    },
    {
      id: 3,
      iconId: "studentIcon",
      label: "Student Details",
      action: () => setCurrent(5),
    },
    {
      id: 4,
      iconId: "discontinuedIcon",
      label: "Discontinued Details",
      action: () => setCurrent(6),
    },
    {
      id: 5,
      iconId: "formAIcon",
      label: "Form A",
      action: () => handleForm(showLoader, hideLoader, navigate, "forma"),
    },
    {
      id: 6,
      iconId: "formBIcon",
      label: "Form B",
      action: () => handleForm(showLoader, hideLoader, navigate, "formb"),
    },
    {
      id: 7,
      iconId: "formCIcon",
      label: "Form C",
      action: () => handleForm(showLoader, hideLoader, navigate, "formc"),
    },
    {
      id: 8,
      iconId: "formDIcon",
      label: "Form D",
      action: () => handleForm(showLoader, hideLoader, navigate, "formd"),
    },
    {
      id: 9,
      iconId: "formFGIcon",
      label: "Form FG",
      action: () => handleForm(showLoader, hideLoader, navigate, "formfg"),
    },
    {
      id: 10,
      iconId: "formLEAIcon",
      label: "Form LEA2026",
      action: () => handleForm(showLoader, hideLoader, navigate, "formlea"),
    },
    {
      id: 11,
      iconId: "formApproved",
      label: "Approved Details",
      action: () =>
        handleForm(
          showLoader,
          hideLoader,
          navigate,
          "formApprv",
          undefined,
          undefined,
          undefined,
          undefined,
          1
        ),
    },
    {
      id: 12,
      iconId: "formNotApproved",
      label: "Not Approved Details",
      action: () =>
        handleForm(
          showLoader,
          hideLoader,
          navigate,
          "formApprv",
          undefined,
          undefined,
          undefined,
          undefined,
          0
        ),
    },
  ];

  const adminMenuItems = [
    { id: 0, label: "Home", iconId: "homeIcon", action: () => setCurrent(0) },
    {
      id: 1,
      label: "Approved Details By college",
      iconId: "studentIcon",
      action: () => setCurrent(1),
    },
  ];
  const collegeCode = "5901";
  const adminFormItems = [
    {
      id: 2,
      label: "Form A",
      iconId: "formIcon",
      action: () => handleForm(showLoader, hideLoader, navigate, "forma", true),
    },
    {
      id: 3,
      label: "Form B",
      iconId: "formIcon",
      action: () => handleForm(showLoader, hideLoader, navigate, "formb", true),
    },
    {
      id: 4,
      label: "Form C",
      iconId: "formIcon",
      action: () => handleForm(showLoader, hideLoader, navigate, "formc", true),
    },
    {
      id: 5,
      label: "Form D",
      iconId: "formIcon",
      action: () => handleForm(showLoader, hideLoader, navigate, "formd", true),
    },
    {
      id: 6,
      label: "Form FG",
      iconId: "formIcon",
      action: () =>
        handleForm(showLoader, hideLoader, navigate, "formfg", true),
    },
    { id: 7, label: "Abstract Form", iconId: "formIcon" ,action: () => handleForm(showLoader, hideLoader,navigate,"abstract_form",true,true)},
    { id: 8, label: "Note Order", iconId: "formIcon", action: () => handleForm(showLoader, hideLoader, navigate, "noteOrder", true, true) },
    { id: 9, label: "Note Order-Approved", iconId: "formIcon", action: () => handleForm(showLoader, hideLoader, navigate, "noteOrderApprvGen", true, true) },
    {
      id: 10,
      label: "Note Order-Not Approved/Pending",
      iconId: "formIcon",
      action: () =>
        handleForm(
          showLoader,
          hideLoader,
          navigate,
          "noteOrderPending",
          true,
          true
        ),
      },
    { id: 11, label: "Principal/Letter", iconId: "formIcon" , action: () => handleForm(showLoader, hideLoader, navigate, "principal_letter", true,true)},
    {
      id: 12,
      label: "Principal-Approved",
      iconId: "formIcon",
      action: () =>
        handleForm(
          showLoader,
          hideLoader,
          navigate,
          "principal-approved",
          true,
          true
        ),
    },
    {
      id: 13,
      label: "Principal-Not Approved",
      iconId: "formIcon",
      action: () =>
        handleForm(
          showLoader,
          hideLoader,
          navigate,
          "principal-notapproved",
          true,
          true
        ),
    },
  ];

  const adminFgaItems = [
    {
      id: 14,
      label: "OC/BCM/BC/MBC/DNC",
      iconId: "formIcon",
      action: () =>
        handleForm(
          showLoader,
          hideLoader,
          navigate,
          "fg_form",
          true,
          ["oc", "bc", "bcm", "mbc"],
          true
        ),
    },
    {
      id: 15,
      label: "SC/SCA",
      iconId: "formIcon",
      action: () =>
        handleForm(
          showLoader,
          hideLoader,
          navigate,
          "fg_form",
          true,
          ["sc", "sca"],
          true
        ),
    },
    {
      id: 16,
      label: "ST",
      iconId: "formIcon",
      action: () =>
        handleForm(
          showLoader,
          hideLoader,
          navigate,
          "fg_form",
          true,
          ["st"],
          true
        ),
    },
  ];

  const adminFgItems = [
    {
      id: 17,
      label: "OC/BCM/BC/MBC/DNC", 
      iconId: "formIcon",
      action: () =>
        handleForm(
          showLoader,
          hideLoader,
          navigate,
          "fg_form",
          true,
          ["oc", "bc", "bcm", "mbc"],
          false
        ),
    },
    {
      id: 18,
      label: "SC/SCA",
      iconId: "formIcon",
      action: () =>
        handleForm(
          showLoader,
          hideLoader,
          navigate,
          "fg_form",
          true,
          ["sc", "sca"],
          false
        ),
    },
    {
      id: 19,
      label: "ST",
      iconId: "formIcon",
      action: () =>
        handleForm(
          showLoader,
          hideLoader,
          navigate,
          "fg_form",
          true,
          ["st"],
          false
        ),
    },
  ];

  const adminSubItems = [
    {
      id: 20,
      label: "Student Details",
      iconId: "studentIcon",
      action: () => setCurrent(2),
    },
  
  ];
  const adminFormsItems = [
    { 
      id: 21,
      label: "Note Order-Approved",
      iconId: "formIcon",
      action: () => handleForm(showLoader, hideLoader, navigate, "noteOrderApproved", true,[], true,true)
    },
  ];
  const adminFGItems = [
    {
      id: 22,
      label: "OC/BCM/BC/MBC/DNC",
      iconId: "formIcon",
      action: () =>
        handleForm(
          showLoader,
          hideLoader,
          navigate,
          "fg_form",
          true,
          ["oc", "bc", "bcm", "mbc"],
          true,
          true
        ),
    },
    {
      id: 23,
      label: "SC/SCA",
      iconId: "formIcon",
      action: () =>
        handleForm(
          showLoader,
          hideLoader,
          navigate,
          "fg_form",
          true,
          ["sc", "sca"],
          true,
          true
        ),
    },
    {
      id: 24,
      label: "ST",
      iconId: "formIcon",
      action: () =>
        handleForm(
          showLoader,
          hideLoader,
          navigate,
          "fg_form",
          true,
          ["st"],
          true,
          true
        ),
    },
  ];

  const sideBarList = [
    [adminMenuItems, "MENU"],
    [adminFormItems, "FORM GENERATION"],
    [adminFgaItems, "FG APPROVED"],
    [adminFgItems, "FG NOT APPROVED"],
    // [adminSubItems, "SUPPLEMENTARY APPROVAL"],
    // [adminFormsItems, "FORMS"],
    // [adminFGItems, "FG"],
  ];

  const [collapsed, setCollapsed] = useState(false);
  const getActiveIdFromCurrent = (currentVal) => {
    if (currentVal === 5) return 3;
    if (currentVal === 6) return 4;
    if (currentVal === 3 || currentVal === 4) return 2;
    return currentVal;
  };

  const [activeAdminId, setActiveAdminId] = useState(
    getActiveIdFromCurrent(Number(localStorage.getItem("current")) || 0)
  );

  useEffect(() => {
    if (!admin) {
      setActiveAdminId(getActiveIdFromCurrent(Number(current)));
    } else {
      setActiveAdminId(getActiveAdminId(Number(current)));
    }
  }, [current]);

  const toggleSidebar = () => setCollapsed((prev) => !prev);

  const handleItemClick = (index, action) => {
    if (!admin && submitted) {
      if (index < 1) setActiveAdminId(index);
      if (action) action();
    } else if (!admin) {
      if (index < 5) setActiveAdminId(index);
      if (action) action();
    }
  };

  const handleAdminClick = (id, action) => {
    if (id === 0 || id === 1 ||id === 2  || id === 3 || id === 4 || id === 5 || id === 6 || id === 20) {
      setActiveAdminId(getActiveAdminId(id));
    }
    if (action) action();
  };

  function getActiveAdminId(currentVal) {
    if (currentVal === 2 || currentVal === 3 || currentVal === 4 || currentVal === 5 || currentVal === 6  ) return 1;
    return currentVal;
  }


  return (
    <div
      id="sidebar"
      className={collapsed ? "collapsed" : ""}
      style={{ paddingRight: admin ? "0px" : collapsed ? "0px" : "13px" }}
    >
      <div id="iconDiv" onClick={toggleSidebar}>
        <div id="listIcon"></div>
      </div>
      {!admin ? (
        <>
          {items
            .filter((item) => {
              if (submitted) {
                if (
                  item.id === 1 ||
                  item.id === 2 ||
                  item.id === 3 ||
                  item.id === 4
                ) {
                  return false;
                }
                return true;
              } else {
                if (item.id === 11 || item.id === 12) {
                  return false;
                }
                return true;
              }
            })
            .map((item, index) => (
              <div
                style={{ fontWeight: "bold" }}
                key={item.id}
                className={`menuItems ${
                  activeAdminId === index ? "active" : ""
                }`}
                onClick={() => handleItemClick(index, item.action)}
              >
                <div id={item.iconId}></div>
                {!collapsed && item.label}
              </div>
            ))}
          {!collapsed && !submitted && (
            <div id="buttonDiv">
              <Button name="FREEZE" onClick={handleSubmit} />
            </div>
          )}
        </>
      ) : (
        <div id="sideMenu">
          <br />
          {sideBarList.map(([list, title], sectionIndex) => (
            <div key={sectionIndex}>
              {!collapsed && (
                <div className="sectionTitle" style={{ fontWeight: "bold" }}>
                  {title}
                </div>
              )}
              {list.map((item) => (
                <div
                  key={item.id}
                  className={`menuItems 
                    ${item.id === activeAdminId ? "active" : ""}
                    ${item.id !== 0 && item.id !== 20 ? "nonActive" : ""}
                  `}
                  onClick={() => handleAdminClick(item.id, item.action)}
                >
                  <div id={item.iconId}></div>
                  {!collapsed && item.label}
                </div>
              ))}
              <br />
            </div>
          ))}
          {!collapsed && (
            <>
              <div id="sideCollegeDetails">COLLEGE DETAILS</div>
              <div id="buttonDiv">
                <Button
                  name="College Details Pdf"
                  onClick={() =>
                    handleForm(
                      showLoader,
                      hideLoader,
                      navigate,
                      "collegeDetails",
                      true,
                      true,
                    )
                  }
                />
              </div>
            </>
          )}
        </div>
      )}
      <Alert
        type={alertType}
        message={alertMessage}
        show={showAlert}
        okbutton={alertOkAction}
        cancelbutton={alertStage === "confirm" ? handlecloseAlert : null}
      />
    </div>
  );
}

export default Sidebar;
